<template>
    <div class="col-md-12">
      <div class="box box-default">
        <!-- /.box-header -->
        <div class="box-body">
          <div v-if="this.$route.query.status === 'success'">
            <div class="jumbotron text-center">
              <h1 class="display-3">Thank You!</h1>
              <p class="lead text-success"><strong>This is a confirmation message that we’ve received your payment.</strong> </p>
              <p>Status: {{this.$route.query.message}}
                <br>
                Transaction Id : {{this.$route.query.transaction_id}}
                <br>
                Order Id : {{this.$route.query.order_id}}</p>
              <hr>
              <p>
                Having trouble? <a>Contact us</a>
              </p>
              <p class="lead">
                <router-link to="/emiCollection" class="btn btn-primary btn-flat"><i class="fa fa-hand-o-left"></i> Back</router-link>
                <button class="btn btn-info btn-flat" @click="printPaytmView(paytmRecords)"><i class="fa fa-eye"></i> View Receipt</button>
                <!-- <a class="btn btn-primary btn-flat" href="https://bootstrapcreative.com/" role="button">Go Back</a> -->
              </p>
            </div>
            <!-- <h4 class="text-center">{{this.$route.query.status}}</h4>

            <p>{{this.$route.query.message}}</p> -->
          </div>
          <div class="callout callout-danger" v-if="this.$route.query.status !== 'success'">
            <div class="jumbotron text-center">
              <h1 class="display-3">Transaction Failed!</h1>
              <p class="lead text-danger"><strong>Oh no, Your Payment Failed</strong> </p>
              <p>Status: {{this.$route.query.message}}
                <br>
                Transaction Id : {{this.$route.query.transaction_id}}
                <br>
                Order Id : {{this.$route.query.order_id}}</p>
              <hr>
              <p>
                Having trouble? <a>Contact us</a>
              </p>
              <p class="lead">
                <router-link to="/emiCollection" class="btn btn-primary btn-flat"><i class="fa fa-hand-o-left"></i> Back</router-link>
                <button class="btn btn-info btn-flat" @click="printPaytmView(paytmRecords)"><i class="fa fa-eye"></i> View Receipt</button>
                <!-- <a class="btn btn-primary btn-flat" href="https://bootstrapcreative.com/" role="button">Go Back</a> -->
              </p>
            </div>
          </div>
        </div>
        <!-- /.box-body -->
      </div>
      <!-- /.box -->
      <!-- Payment Receipt Model -->
      <paytmreceiptview :seeRecord="seeRecord" :getCompanyRecord="getCompanyRecord"></paytmreceiptview>
    </div>
</template>
<script>
import paytmreceiptview from '../microfinance/components/PaytmReceipt.vue'
export default {
  name: 'Paytm',
  data () {
    return {
      paytmRecords: {},
      getCompanyRecord: {},
      seeRecord: {}
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    printPaytmView (row) {
      this.seeRecord = {}
      this.seeRecord = row
      $('#paytmreceiptview').modal({backdrop: 'static', keyboard: false})
    },
    loadCompanyProfile () {
      let loader = this.$loading.show()
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.getCompanyRecord = data
          if (this.getCompanyRecord.logo != null) {
            this.logo = this.$store.state.imageBaseUrl + 'logo/' + this.getCompanyRecord.logo
          } else {
            alert('hello')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadData () {
      let loader = this.$loading.show()
      this.$axios
        .get('paytm?transaction_id=' + this.$route.query.transaction_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          console.log(data.data.data)
          loader.hide()
          this.paytmRecords = data.data.data[0]
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  components: {
    paytmreceiptview
  },
  created () {
    this.loadData()
    this.loadCompanyProfile()
  }
}
</script>



// WEBPACK FOOTER //
// Thankyou.vue?5867f000